module.exports = __webpack_public_path__ + "img/promoters.d3598d82.svg";